import { Attachment } from '@web/conversations/types/Attachment';

export const escapeAttachmentUrl = (attachments: Attachment[] = []): Attachment[] => {
  // Return URLs as-is from server - no encoding needed for direct rendering
  // URLs should be used directly in img src, href, etc. without encoding
  return attachments;
};
